import McpChatResource from '../resources/McpChatResource';

class McpChatService {
  /**
   * @param {string} message
   * @param {string|null} conversationId
   * @returns {Promise<{message: string, conversation_id: string, tools_used: string[]}>}
   */
  async sendMessage(message, conversationId = null, pageContext = null) {
    return McpChatResource.sendMessage(message, conversationId, pageContext);
  }

  async executeAgent(agentKey, contextPayload, conversationId = null, pageContext = null) {
    return McpChatResource.executeAgent(agentKey, contextPayload, conversationId, pageContext);
  }

  async getHistory(params = {}) {
    return McpChatResource.getHistory(params);
  }

  async getConversation(conversationId) {
    return McpChatResource.getConversation(conversationId);
  }

  async getSuggestionPrompts() {
    return McpChatResource.getSuggestionPrompts();
  }
}

export default new McpChatService();
